export const lbl = {
  display: 'block',
  fontSize: 11,
  fontWeight: 700,
  color: '#1a3364',
  letterSpacing: '0.06em',
  textTransform: 'uppercase',
  marginBottom: 5,
};

export const inp = {
  width: '100%',
  padding: '10px 12px',
  border: '1.5px solid #c5d5e8',
  borderRadius: 8,
  fontSize: 15,
  color: '#1a3364',
  background: '#fff',
  outline: 'none',
  display: 'block',
};

export const row2 = {
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: 14,
  marginBottom: 18,
};

export const row3 = {
  display: 'grid',
  gridTemplateColumns: '2fr 1.5fr 2fr',
  gap: 14,
  marginBottom: 18,
};

export const smallBtn = {
  border: '1.5px solid #c5d5e8',
  background: '#fff',
  color: '#1a3364',
  borderRadius: 8,
  padding: '8px 12px',
  fontWeight: 800,
  cursor: 'pointer',
};

export function noAutofill(name) {
  return {
    name: `indfam-${name}`,
    autoComplete: 'new-password',
    autoCorrect: 'off',
    spellCheck: false,
  };
}

export function formatPhone(val) {
  const digits = String(val || '').replace(/\D/g, '').slice(0, 10);
  if (digits.length < 4) return digits;
  if (digits.length < 7) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
}

export function parseHeight(value) {
  const raw = String(value || '').trim();
  const oldFormat = raw.match(/^(\d+)'(\d+)"?$/);
  if (oldFormat) return { feet: oldFormat[1], inches: oldFormat[2] };
  const total = Number.parseInt(raw, 10);
  if (Number.isFinite(total) && total > 0) {
    return { feet: String(Math.floor(total / 12)), inches: String(total % 12) };
  }
  return { feet: '', inches: '' };
}

export function formatHeight(value) {
  const { feet, inches } = parseHeight(value);
  return feet ? `${feet} ft ${inches || 0} in` : '';
}

export function heightToInches(feet, inches) {
  if (!feet) return '';
  return String((Number(feet) * 12) + Number(inches || 0));
}
